import { Link } from "react-router-dom";
import { useStore } from "../context/StoreContext";

export default function NotFound() {
  const { L } = useStore();
  return (
    <div className="pt-40 pb-32 min-h-screen flex flex-col items-center justify-center text-center px-5" data-testid="not-found-page">
      <p className="font-arabic text-gold text-3xl" dir="rtl">أَرِيجُ المِسْكِ</p>
      <h1 className="font-display text-4xl sm:text-5xl text-ivory mt-6">{L.notFound.title}</h1>
      <p className="font-display text-6xl text-gold/30 mt-2">404</p>
      <Link to="/" data-testid="not-found-cta" className="btn-gold rounded-full px-8 py-3.5 text-[0.7rem] tracking-[0.25em] uppercase font-semibold mt-8">
        {L.notFound.cta}
      </Link>
    </div>
  );
}
